import React, { useEffect, useState, useCallback } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import SectorsGrid from "@/components/SectorsGrid";
import NewsletterSection from "@/components/NewsletterSection";
import YouTubeSection from "@/components/YouTubeSection";
import EventsSection from "@/components/EventsSection";
import { Meta } from "@/lib/api";
import { useNewsletterModal } from "@/lib/modal";
import { useExitIntent } from "@/lib/useExitIntent";

export default function Home() {
    const [meta, setMeta] = useState(null);
    const { openNewsletter, isNewsletterOpen } = useNewsletterModal();

    useEffect(() => {
        Meta.get().then(setMeta).catch(() => {});
    }, []);

    const onExit = useCallback(() => {
        if (!isNewsletterOpen) openNewsletter();
    }, [isNewsletterOpen, openNewsletter]);

    useExitIntent(onExit);

    return (
        <div className="min-h-screen" data-testid="home-page">
            <Header />
            <main>
                <Hero stats={meta?.stats} />
                <NewsletterSection />
                <YouTubeSection />
                <EventsSection />
                <SectorsGrid />
            </main>
            <Footer />
        </div>
    );
}
